module.exports = __webpack_public_path__ + "img/Hello-mobile.57af579d.webp";